var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//  @jsx h

/* eslint-disable jsx-a11y/media-has-caption */

import { h } from 'preact';
import PureComponent from '../lib/preact-pure-component';

var Video = function (_PureComponent) {
  _inherits(Video, _PureComponent);

  function Video() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Video);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Video.__proto__ || Object.getPrototypeOf(Video)).call.apply(_ref, [this].concat(args))), _this), _this.handleCanPlay = function (event) {
      var onCanPlay = _this.props.onCanPlay;

      if (typeof onCanPlay !== 'undefined') {
        onCanPlay(event);
      }
    }, _this.handlePlay = function (event) {
      var onPlay = _this.props.onPlay;

      if (onPlay) {
        onPlay(event);
      }
    }, _this.handlePause = function (event) {
      var onPause = _this.props.onPause;

      if (onPause) {
        onPause(event);
      }
    }, _this.handleDurationChange = function (event) {
      var onDurationChange = _this.props.onDurationChange;

      if (onDurationChange) {
        onDurationChange(event);
      }
    }, _this.handleTimeUpdate = function (event) {
      var onTimeUpdate = _this.props.onTimeUpdate;

      if (onTimeUpdate) {
        onTimeUpdate(event);
      }
    }, _this.handleEnded = function (event) {
      var onEnded = _this.props.onEnded;

      if (typeof onEnded !== 'undefined') {
        onEnded(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Video, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var elm = this.elm;
      var _props = this.props,
          captions = _props.captions,
          playing = _props.playing,
          onCaptionCueEnter = _props.onCaptionCueEnter,
          onCaptionCueExit = _props.onCaptionCueExit;

      elm.addEventListener('canplay', this.handleCanPlay);
      elm.addEventListener('play', this.handlePlay);
      elm.addEventListener('ended', this.handleEnded);
      elm.addEventListener('pause', this.handlePause);
      elm.addEventListener('durationchange', this.handleDurationChange);
      elm.addEventListener('timeupdate', this.handleTimeUpdate);

      if (captions) {
        this.track = elm.addTextTrack('subtitles', 'Norsk');

        try {
          captions.forEach(function (a) {
            return _this2.track.addCue(new window.VTTCue(Number(a.in), Number(a.out), a.text));
          });
        } catch (ex) {
          captions.forEach(function (a) {
            return _this2.track.addCue(new window.TextTrackCue(Number(a.in), Number(a.out), a.text));
          });
        }

        this.track.mode = 'hidden';

        var _loop = function _loop(i) {
          var cue = _this2.track.cues[i];

          try {
            cue.onenter = function () {
              if (typeof onCaptionCueEnter !== 'undefined') {
                onCaptionCueEnter(cue);
              }
            };
            cue.onexit = function () {
              if (typeof onCaptionCueExit !== 'undefined') {
                onCaptionCueExit();
              }
            };
          } catch (_) {
            // discard error
          }
        };

        for (var i = 0; i < this.track.cues.length; i++) {
          _loop(i);
        }
      }

      if (playing) {
        elm.play();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          playing = _props2.playing,
          muted = _props2.muted;
      // Update pause or play state

      if (prevProps.playing && !playing) {
        this.elm.pause();
      }
      if (!prevProps.playing && playing) {
        this.elm.play();
      }
      // Updated `muted`
      if (prevProps.muted !== muted) {
        this.elm.muted = muted || false;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var elm = this.elm;

      elm.removeEventListener('canplay', this.handleCanPlay);
      elm.removeEventListener('play', this.handlePlay);
      elm.removeEventListener('ended', this.handleEnded);
      elm.removeEventListener('pause', this.handlePause);
      elm.removeEventListener('durationchange', this.handleDurationChange);
      elm.removeEventListener('timeupdate', this.handleTimeUpdate);
    }
  }, {
    key: 'play',
    value: function play() {
      this.elm.play();
    }
  }, {
    key: 'updateTime',
    value: function updateTime(time) {
      this.elm.currentTime = time;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          controls = _props3.controls,
          loop = _props3.loop,
          sources = _props3.sources,
          poster = _props3.poster;

      var preload = this.props.preload || 'none';
      var muted = this.props.muted || false;
      return h(
        'video',
        {
          controls: controls,
          preload: preload,
          ref: function ref(elm) {
            return _this3.elm = elm;
          },
          loop: loop,
          muted: muted,
          playsInline: true,
          poster: poster,
          className: this.props.className,
          style: this.props.style
        },
        sources.map(function (source) {
          return h('source', { key: source.src, src: source.src, type: source.type });
        })
      );
    }
  }]);

  return Video;
}(PureComponent);

export default Video;